import styled from "styled-components";

export const DonationDetailsCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: auto;
  width: 60%;
`

export const DonationDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
`

export const DonationDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const DonationDetailsP = styled.p`
  font-size: var(--font-size-xs);
  width: fit-content;
  margin-right: 15px;
  color: var(--color-order-detail-subtext);
`

export const DonationDetailsName = styled.p`
  font-size: var(--font-size-sm);
  width: fit-content;
  margin-right: 15px;
  color: var(--color-order-detail-subtext);
`

export const ShowMoreTextStyleWrapper = styled.div`
  font-size: var(--font-size-xs);
  margin-bottom: auto;
  margin-right: 15px;
  align-items: center;
  color: var(--color-order-detail-subtext);
`

export const DonationDetailHeader = styled.p`
  font-size: var(--font-size-sm);
  width: fit-content;
  max-width: 100%;
  text-align: left;
  margin-right: 15px;
  margin-bottom: 5px;
`

export const DonationAmountRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
`

export const DonationAmountDollars = styled.p`
  font-size: var(--font-size-l);
`

export const DonationAmountCents = styled.p`
  font-size: var(--font-size-md);
  margin-top: auto;
  margin-bottom: 1px;
`

export const DonationCurrency = styled.p`
  font-size: var(--font-size-md);
  margin-top: auto;
  margin-bottom: auto;
`

export const DonationDetailsBody = styled.div`
  margin-top: 0px;
  margin-bottom: auto;
`

export const DonationImageWrapper = styled.div`
  max-width: 35%;
`

export const DonationImage = styled.img`
  aspect-ratio: 16 / 9;
  width: 100%;
  object-fit: cover;
`